import $ from "expose-loader?exposes=$,jQuery!jquery";
import 'bootstrap';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../global/settings';
import { printNoCommentsInit, printWithCommentsInit, handlePrintWithComments, handlePrintWithNoComments } from '../utils/util';

// import  * as pdf_util from './utils/pdf_util';

// pdf_util.globalRender(1.5);

// MAIN SIDE NAVIGATION PANEL
const toggleMainSideNav = (e) => {
  e.preventDefault();
  if (document.body.classList.toggle('push')) {
    // hide other menu panels when main menu is out
    document.body.classList.remove('cal-item-push', 'enrolling-push');
  }
};

document.addEventListener('click', (e) => {
  let target = e.target;

  if (target.closest('.main-side-nav-trigger')) {
    toggleMainSideNav(e);
  }
});

document
  .getElementById('app-bill-search-form')
  .addEventListener('submit', (e) => {
    e.preventDefault();
    const form = e.target;
    const bill = form.search.value;
    window.location.assign(
      `${window.location.protocol}//${window.location.host}/bills/${bill}`
    );
  });

  document.addEventListener('click', (event) => {
    // Check if the clicked element is #printWithCommentsBtn
    if (event.target.id === 'printWithCommentsBtn') {
      // handling the button click
      console.log('printWithCommentsBtn clicked!');
  
      // Trigger printing logic
      handlePrintWithComments();
      // init the print functions, in case the buttons are used again
      printWithCommentsInit();
    }
    else if (event.target.id === 'printNoCommentBtn') {
      // handling the button click
      console.log('printNoCommentBtn clicked!');
  
      // Trigger printing logic
      handlePrintWithNoComments();
      // init the print functions, in case the buttons are used again
      printNoCommentsInit();
    }
  });

printNoCommentsInit();
printWithCommentsInit();

